import { useCallback } from 'react';
import { useNote, type Note } from '../components/ui';
import { useT } from '../lib/i18n';
import type { StringKey } from '../lib/strings';

/**
 * Things the mockup shows that the server can't do yet. Tapping one says so plainly, in a line right where the
 * rider tapped (no popup). Each one is a gap in docs/OWNER-DECISIONS.md §8.
 */
export type Soon = 'driver' | 'terms' | 'whatsapp' | 'upi' | 'call' | 'message' | 'help' | 'schedule';

export function useSoon(): [Note, (which: Soon) => void, (text: string | null, tone?: 'info' | 'error' | 'good') => void] {
  const t = useT();
  const [note, say] = useNote(7000);
  const soon = useCallback((which: Soon) => say(t(`soon.${which}.body` as StringKey)), [say, t]);
  return [note, soon, say];
}
